__turbopack_context__.v({
  "headerContainer": "CommunityNavSubHeader-module-scss-module__Ca6Mpq__headerContainer",
  "mobileStickyWrapper": "CommunityNavSubHeader-module-scss-module__Ca6Mpq__mobileStickyWrapper",
});
